import { ApolloClient, ApolloLink, InMemoryCache, from } from '@apollo/client';
import { HttpLink } from '@apollo/client/link/http';
import { createWorkflowComponentTypePolicies } from '@shared/api/client';
import {
  errorLoggerLink,
  removeTypenameFromMutationLink,
  stampWorkflowTemplateIdLink,
} from '@shared/api/customApolloLinks';
import possibleTypes from '@shared/api/possibleTypes.json';
import { MBSentry } from '@shared/util/sentry';

export let apolloClient: ApolloClient<unknown> | undefined = undefined;

export function createApolloClient(responseHeadersLinks: ApolloLink[] = []): ApolloClient<unknown> {
  const queryLoggerLink = new ApolloLink((operation, forward) => {
    MBSentry.breadcrumbFromApolloOperation(operation);
    return forward(operation);
  });
  const httpLink = new HttpLink({ uri: `${import.meta.env.VITE_API_URL}/api/graphql` });
  apolloClient = new ApolloClient({
    link: from([
      queryLoggerLink,
      errorLoggerLink,
      removeTypenameFromMutationLink,
      stampWorkflowTemplateIdLink,
      ...responseHeadersLinks,
      httpLink,
    ]),
    cache: new InMemoryCache({
      possibleTypes,
      dataIdFromObject(object: any) {
        if (object.__typename === 'Channel') {
          return `${object.__typename}${object.slug}`;
        }
        if (!!object.id && !!object.__typename) {
          return `${object.__typename}${object.id}`;
        }

        return undefined;
      },
      // https://www.apollographql.com/docs/react/local-state/managing-state-with-field-policies/
      typePolicies: {
        ...createWorkflowComponentTypePolicies(possibleTypes.AnyComponent),
      },
    }),
    queryDeduplication: true,
    defaultOptions: {
      query: { fetchPolicy: 'cache-first' },
    },
  });
  return apolloClient;
}
